import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const bannerVisible = atom<boolean>({
    key: 'bannerVisible',
    default: false,
});

export const useBannerVisibleValue = () => useRecoilValue(bannerVisible);
export const useBannerVisibleSetState = () => useSetRecoilState(bannerVisible);
